export default "__VITE_ASSET__1a6f1f2d__"